import React from 'react';

export function LoadingSpinner({ size = 'md', color = 'primary' }) {
  const sizes = { sm: 'w-4 h-4', md: 'w-8 h-8', lg: 'w-12 h-12' };
  const colors = {
    primary: 'border-primary-600',
    white: 'border-white',
    accent: 'border-accent-500',
  };
  return (
    <div
      className={`${sizes[size]} border-2 ${colors[color]} border-t-transparent rounded-full animate-spin`}
    />
  );
}

export function PageLoader() {
  return (
    <div className="min-h-screen bg-cream flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="w-16 h-16 mx-auto">
          <div className="w-16 h-16 border-3 border-primary-600 border-t-transparent rounded-full animate-spin" />
        </div>
        <div className="font-display text-primary-700 text-lg">Ndalem Mataram</div>
        <div className="text-primary-500 text-xs font-sans tracking-widest uppercase animate-pulse">
          Memuat...
        </div>
      </div>
    </div>
  );
}

export function SectionLoader() {
  return (
    <div className="flex items-center justify-center py-20">
      <LoadingSpinner size="lg" />
    </div>
  );
}
